import { render, staticRenderFns } from "./IpqcTemplateList.vue?vue&type=template&id=facea9f6&"
import script from "./IpqcTemplateList.vue?vue&type=script&lang=js&"
export * from "./IpqcTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports